import React from 'react'
import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'
import { useState, useEffect } from 'react'
import { getDocs } from 'firebase/firestore'
import { currentCollectionRef } from '../../firebase/Firebase'
import './current_work.css'

function CurrentWork() {
  const [current_work, setCurrent] = useState("");

  useEffect(() => {
    const getCurrent = async () => {
      const data = await getDocs(currentCollectionRef)
      setCurrent(data.docs.map((doc) => ({...doc.data()}))[0].Current_work_link)
    }

    getCurrent()
  },[])

  return (
    <div className='current_work'>
      <Navbar/>
      <h1>Current Work</h1>
      <hr/>
      <div className='currentContainer'>
        <iframe src={ current_work } style={{
          borderWidth:'0',
          paddingTop: '7.5vh',
          paddingBottom: '7.5vh'
        }} width={1000} height={710} frameBorder={0}></iframe>
      </div>
      <Footer/>
    </div>
  )
}


export default CurrentWork
